export const AdRightSidebar = () => {
    return (
        <div
            data-aaad="true"
            data-aa-adunit="/275516369/ImageResizer_RightSidebar"
            className="flex items-center justify-center"
        ></div>
    );
};
